module.exports = "<p>\n  about works!\n</p>\n"